import baLogoLight from 'assets/images/ba_Logo_Light.svg';
import baLogoDark from 'assets/images/ba_Logo_Dark.svg';

export function PoweredByBa() {
  return (
    <div className="flex items-center justify-center gap-1.5 text-sm leading-[1.2] text-[#5d5d5d]">
      <span>Powered by</span>
      <a
        href="https://agents.seliseblocks.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="BA"
      >
        <img
          src={baLogoLight}
          alt="BA"
          className="h-8 w-auto object-contain dark:hidden"
        />
        <img
          src={baLogoDark}
          alt="BA"
          className="hidden h-8 w-auto object-contain dark:block"
        />
      </a>
    </div>
  );
}
